import { n as e, r as t, t as n, v as r, y as i } from "./apiUrls-CJS1Qk_E.js";
//#region src/composables/useIamService.ts
function a() {
	return {
		getAccount: async () => (await t()).data,
		getToken: () => r.getConfig().auth,
		initClient: (t = { token: void 0 }) => {
			if (!t.token) throw Error("Token is required");
			let a = {
				baseUrl: e,
				auth: t.token,
				querySerializer: i()
			};
			return t.environment && t.environment === "acceptance" && (a.baseUrl = n), t.locale && (a.headers = {
				...a.headers,
				"Accept-Language": t.locale
			}), r.setConfig(a), t.token;
		},
		setAcceptLanguageHeader: (e) => {
			r.setConfig({ headers: {
				...r.getConfig().headers,
				"Accept-Language": e
			} });
		}
	};
}
//#endregion
export { a as t };
